<template>
  <v-card
    ref="refComponent"
    class="ma-0 px-1"
    width="100%"
    style="direction: rtl"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="40"
    >
      <v-toolbar-title class="me-5">
        {{ $t(type) }}
      </v-toolbar-title>
      <v-tabs
        v-show="!isMobile"
        v-model="tab"
        style="width: 400px"
      >
        <v-tab>
          {{ $t('public-information') }}
        </v-tab>
        <v-tab>{{ $t('addtional-information') }}</v-tab>
      </v-tabs>
      <v-spacer />
      <!--      <v-btn-->
      <!--        color="primary"-->
      <!--        class="mx-4 mt-2"-->
      <!--        height="32"-->
      <!--        style="background-color: #4CAF50 !important;"-->
      <!--        @click="printWithTools()"-->
      <!--      >-->
      <!--        print-->
      <!--      </v-btn>-->
      <v-btn
        v-if="(!id && !isMobile) && !sellLinkProp "
        color="primary"
        class="mx-4 mt-2"
        height="32"
        style="background-color: #4CAF50 !important;"
        :loading="isLoading"
        @click="create"
      >
        {{ $t('submit') }} (f3)
      </v-btn>
      <v-btn
        v-if="id && !isMobile"
        color="primary"
        class="mx-4 mt-2"
        height="32"
        style="background-color: #4CAF50 !important;"
        :loading="isLoading"
        @click="update"
      >
        {{ $t('submit') }}
      </v-btn>
      <div
        v-if="!isMobile"
        style="width: 200px"
      >
        <v-text-field
          v-model="numberForEdit"
          height="30"
          dense
          class="mb-3 me-3 mt-1"
          hide-details
          outlined
          type="number"
          clearable
          :label="$t('callNumberForEdit')"
          @click:clear="clearableForm"
          @keydown="callInvoiceById($event)"
          @focus="focusEvent"
        />
      </div>
      <!--      <v-spacer />-->
      <!--      <v-tooltip bottom>-->
      <!--        <template v-slot:activator="{ on, attrs }">-->
      <!--          <v-btn-->
      <!--            v-if="!isMobile && !id"-->
      <!--            v-shortkey="['f3']"-->
      <!--            v-bind="attrs"-->
      <!--            icon-->
      <!--            width="35"-->
      <!--            class="float-left"-->
      <!--            v-on="on"-->
      <!--            @shortkey="create"-->
      <!--            @click="create"-->
      <!--          >-->
      <!--            <v-icon-->
      <!--              color="green"-->
      <!--              style="font-size: 30px"-->
      <!--            >-->
      <!--              mdi-content-save-outline-->
      <!--            </v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->
      <!--        <span>{{ $t('submit') }} (f3)</span>-->
      <!--      </v-tooltip>-->
      <!--      <v-tooltip bottom>-->
      <!--        <template v-slot:activator="{ on, attrs }">-->
      <!--          <v-btn-->
      <!--            v-shortkey="['f10']"-->
      <!--            v-bind="attrs"-->
      <!--            icon-->
      <!--            width="35"-->
      <!--            class="float-left"-->
      <!--            v-on="on"-->
      <!--            @shortkey="fullScreen"-->
      <!--            @click="fullScreen"-->
      <!--          >-->
      <!--            <v-icon-->
      <!--              color="primary"-->
      <!--              style="font-size: 30px"-->
      <!--            >-->
      <!--              mdi-fullscreen-->
      <!--            </v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->
      <!--        <span>{{ $t('fullscreen') }} (f10)</span>-->
      <!--      </v-tooltip>-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="autoPrint = !autoPrint"
          >
            <v-icon
              :color="(autoPrint ? 'blue' : 'grey')"
              style="font-size: 30px"
            >
              {{ (autoPrint ? 'mdi-printer-outline' : 'mdi-printer-off-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('autoPrint') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="abrironPrinter = !abrironPrinter"
          >
            <v-icon
              :color="(abrironPrinter ? 'orange' : 'grey')"
              style="font-size: 30px"
            >
              mdi-printer-pos-cog-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('useAbrironPrinter') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && !id"
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="getAllProductsOffline(type)"
          >
            <v-icon
              color="blue--darken"
              style="font-size: 30px"
            >
              mdi-cloud-download-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('downloadOfflineData') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="showCurrency = !showCurrency"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              {{ (showCurrency ? 'mdi-currency-usd' : 'mdi-currency-usd-off') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('showCurrency') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            width="35"
            class="float-left"
            v-on="on"
            @click="(printType == 'normal' ? printType = 'fish' : printType = 'normal')"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              {{ (printType == 'normal' ? 'mdi-printer-outline' : 'mdi-paper-roll-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ (printType == 'normal' ? $t('normalPrint') : $t('invoiceRollprint')) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            width="35"
            v-on="on"
            @click="goTo( type + 'List' )"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('list') }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            width="35"
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 30px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render || loading"
      :indeterminate="!render || loading"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs
        v-show="isMobile"
        v-model="tab"
      >
        <v-tab>
          {{ $t('public-information') }}
        </v-tab>
        <v-tab>{{ $t('addtional-information') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container
            class="py-0 px-1"
            fluid
          >
            <v-row class="mx-0">
              <v-col
                v-show="bodyStatus == false || !isMobile"
                cols="12"
                md="7"
                sm="6"
                class="px-0 pb-0"
              >
                <products
                  ref="productCategoryRef"
                  v-model="items"
                  :data="JSON.stringify({entrepot : (entrepot ? entrepot.id : null)})"
                  :item-count="(items ? items.length : 0)"
                  :height-prop="tableHeightInvoice"
                  :offline-prop="offline"
                  :type-prop="type"
                  :scale-prop="scale"
                  @append="append"
                  @blur="setFocus"
                  @setOffline="setOffline"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == true || !isMobile"
                cols="12"
                md="5"
                sm="6"
                class="ps-0"
              >
                <v-row class="my-2 mx-0 px-0">
                  <v-col
                    cols="6"
                    class="py-1 px-1"
                    md="2"
                  >
                    <v-text-field
                      v-model="number"
                      height="20"
                      dense
                      :rules="[v => !!v || $t('is-required')]"
                      outlined
                      class="mb-3 dense"
                      clearable
                      :label="$t('number')"
                      @blur="getInvoiceNumber"
                      @focus="focusEvent"
                    />
                  </v-col>
                  <v-col
                    class="px-1 xs py-1"
                    cols="6"
                    :class="{'mb-3' : isMobile}"
                    md="4"
                  >
                    <autocomplete
                      ref="refAccount"
                      v-model="account"
                      title="account"
                      :type="(offline ? 'getAllPersonOffline' : 'person')"
                      :offline="offline"
                      :set-offline="offline"
                      :new-btn="true"
                      :rules="[v => !!v || $t('is-required')]"
                      :value="account"
                    />
                  </v-col>
                  <v-col
                    class="px-1 xs py-1"
                    :class="{'mb-3' : isMobile}"
                    cols="6"
                    md="3"
                  >
                    <autocomplete
                      ref="refEntrepot"
                      v-model="entrepot"
                      title="entrepot"
                      type="entrepot"
                      :set-init="(id ? false : true)"
                      :new-btn="true"
                      :value="entrepot"
                      :offline="offline"
                      :set-offline="offline"
                      @input="checkProductsCount"
                    />
                  </v-col>
                  <v-col
                    class="py-1 px-1"
                    cols="6"
                    md="3"
                    :class="{'mb-3' : isMobile}"
                  >
                    <template>
                      <v-text-field
                        id="from"
                        v-model="date"
                        :label="$t('date')"
                        :rules="[v => !!v || $t('is-required')]"
                        clear-icon="flaticon2-close-cross"
                        outlined
                        hide-details
                        dense
                        clearable
                      />
                      <date-picker
                        v-model="date"
                        element="from"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :max="$store.state.endDate"
                        :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                        @close="setDate"
                      />
                    </template>
                  </v-col>
                  <v-col
                    v-show="false"
                    cols="12"
                    sm="2"
                    md="2"
                    :class="{'mb-3' : isMobile}"
                    class="py-1 px-1"
                  >
                    <aicomplete
                      v-model="branch"
                      title="branch"
                      type="branch"
                      :set-init="true"
                      :val="branch"
                      :offline="offline"
                      :set-offline="offline"
                    />
                  </v-col>
                </v-row>
                <v-row class="my-2 mt-6 mx-0 px-0">
                  <v-col
                    class="px-0 py-0 border-datatable"
                  >
                    <v-row class="mx-0">
                      <v-col
                        ref="refScroll"
                        cols="12"
                        class="my-0 pa-0"
                        :style="{height: (isMobile ? tableHeightInvoice + 65 : tableHeightInvoice + 40) + 'px'}"
                        style="zoom:0.9;overflow-y: scroll;border-top: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;border-right: 1px solid #e3e3e3;"
                      >
                        <v-simple-table
                          class="summary-footer"
                          dense
                        >
                          <template v-slot:default>
                            <thead />
                            <tbody ref="refBody">
                              <tr
                                v-for="(item, index) in items"
                                :key="index"
                              >
                                <td
                                  v-if="item.product"
                                  class="px-0"
                                >
                                  <v-list-item
                                    dense
                                    class="px-0"
                                  >
                                    <v-list-item-icon class="me-1">
                                      <div class="d-flex">
                                        <p class="mt-3">
                                          {{ +index + +1 }}
                                        </p>
                                      <!--                                        <v-menu-->
                                      <!--                                          offset-y-->
                                      <!--                                        >-->
                                      <!--                                          <template v-slot:activator="{ attrs, on }">-->
                                      <!--                                            <v-btn-->
                                      <!--                                              color="primary"-->
                                      <!--                                              v-bind="attrs"-->
                                      <!--                                              icon-->
                                      <!--                                              v-on="on"-->
                                      <!--                                            >-->
                                      <!--                                              <v-icon-->
                                      <!--                                                medium-->
                                      <!--                                              >-->
                                      <!--                                                mdi-dots-vertical-->
                                      <!--                                              </v-icon>-->
                                      <!--                                            </v-btn>-->
                                      <!--                                          </template>-->
                                      <!--                                          <v-list dense>-->
                                      <!--                                            <v-list-item-->
                                      <!--                                              link-->
                                      <!--                                              @click="remove(item)"-->
                                      <!--                                            >-->
                                      <!--                                              <v-list-item-icon>-->
                                      <!--                                                <v-icon color="pink">-->
                                      <!--                                                  mdi-trash-can-outline-->
                                      <!--                                                </v-icon>-->
                                      <!--                                              </v-list-item-icon>-->
                                      <!--                                              <v-list-item-title v-text="$t('remove')" />-->
                                      <!--                                            </v-list-item>-->
                                      <!--                                          </v-list>-->
                                      <!--                                        </v-menu>-->
                                      </div>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title class="text-wrap">
                                        {{ item.product.name }}({{ item.product.code }})
                                      </v-list-item-title>
                                      <v-list-item-subtitle class="text-wrap">
                                        {{ $t('unit') }} : {{ (item.product.unit ? item.product.unit.fame : '') }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action
                                      class="ma-1"
                                    >
                                      <div class="d-flex">
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              v-show="scale"
                                              v-bind="attrs"
                                              :loading="loading"
                                              small
                                              color="blue"
                                              class="me-1"
                                              style="padding: 0px !important;min-width: 30px !important;"
                                              @click="getItemWeight(item)"
                                            >
                                              <v-icon
                                                dark
                                              >
                                                mdi-scale
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('getWeightScale') }}</span>
                                        </v-tooltip>
                                        <v-btn
                                          small
                                          color="green"
                                          class=""
                                          style="padding: 0px !important;min-width: 30px !important;"
                                          @click="addCount(item)"
                                        >
                                          <v-icon
                                            dark
                                          >
                                            mdi-plus
                                          </v-icon>
                                        </v-btn>
                                        <v-text-field
                                          v-model="item.count"
                                          v-disabled-icon-focus
                                          height="20"
                                          dense
                                          solo
                                          hide-details
                                          flat
                                          class="dense"
                                          :rules="[v => !!v || $t('is-required')]"
                                          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                                          :placeholder="$t('count')"
                                          type="number"
                                          style="width: 75px"
                                          @blur="zeroCountCheck(item)"
                                          @input="checkCount(item)"
                                          @focus="(item.count == 0 ? null : item.count)"
                                        />
                                        <v-btn
                                          small
                                          color="pink"
                                          style="padding: 0px !important;min-width: 30px !important;padding-top: 2px"
                                          class="me-1"
                                          @click="minusCount(item)"
                                        >
                                          <v-icon
                                            dark
                                          >
                                            mdi-minus
                                          </v-icon>
                                        </v-btn>
                                        <money
                                          v-model="item.fee"
                                          :dense="true"
                                          :outlined="true"
                                          :label="$t('fee')"
                                          :rules="[feeValidate]"
                                          :solo="false"
                                          :clearable="true"
                                          style="width: 130px"
                                          value-when-is-empty=""
                                          :options="options"
                                          class="mb-3 dense"
                                          :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                                          @input="calcSum"
                                        />
                                      </div>
                                      <div class="d-flex">
                                        <div
                                          class="mt-1 me-1 pa-1"
                                          style="height:29px;width: 232px;background-color: aquamarine;border-radius: 5px"
                                        >
                                          {{ $t('sum') }}: {{ $numberFormat((parseFloat(item.fee) * parseFloat(item.count) + parseFloat(item.tax) - parseFloat(item.discount)).toFixed(decimal)) }}
                                        </div>
                                        <v-btn
                                          small
                                          color="pink"
                                          style="padding: 0px !important;min-width: 30px !important;padding-top: 2px"
                                          class="mt-1"
                                          outlined
                                          @click="remove(item)"
                                        >
                                          <v-icon
                                            dark
                                          >
                                            mdi-trash-can-outline
                                          </v-icon>
                                        </v-btn>
                                      </div>
                                    </v-list-item-action>
                                  </v-list-item>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-row class="mx-0">
                      <v-col
                        cols="12"
                        style="zoom:0.9"
                        class="mb-4 pa-0"
                      >
                        <v-simple-table
                          class="summary-footer"
                          dense
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th
                                  style="border-top : 1px solid #e3e3e3 !important;"
                                >
                                  <div class="d-flex justify-start">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-shortkey="['f2']"
                                          v-bind="attrs"
                                          icon
                                          small
                                          class="float-left"
                                          @shortkey="addRow()"
                                          v-on="on"
                                          @click="addRow()"
                                        >
                                          <v-icon
                                            color="teal"
                                            style="font-size: 22px"
                                          >
                                            mdi-plus-box-outline
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span>{{ $t('newRow') }} (f2)</span>
                                    </v-tooltip>
                                  <!--                                  <v-tooltip bottom>-->
                                  <!--                                    <template v-slot:activator="{ on, attrs }">-->
                                  <!--                                      <v-btn-->
                                  <!--                                        v-shortkey="['f2']"-->
                                  <!--                                        v-bind="attrs"-->
                                  <!--                                        icon-->
                                  <!--                                        small-->
                                  <!--                                        class="float-left"-->
                                  <!--                                        :disabled="(selected.length > 0 ? false : true)"-->
                                  <!--                                        @shortkey="openDeleteDialogVerify()"-->
                                  <!--                                        v-on="on"-->
                                  <!--                                        @click="openDeleteDialogVerify()"-->
                                  <!--                                      >-->
                                  <!--                                        <v-icon-->
                                  <!--                                          color="pink"-->
                                  <!--                                          style="font-size: 22px"-->
                                  <!--                                        >-->
                                  <!--                                          mdi-trash-can-outline-->
                                  <!--                                        </v-icon>-->
                                  <!--                                      </v-btn>-->
                                  <!--                                    </template>-->
                                  <!--                                    <span>{{ $t('remove') }} (f2)</span>-->
                                  <!--                                  </v-tooltip>-->
                                  </div>
                                </th>
                                <th style="border-top : 1px solid #e3e3e3 !important;width: 100px">
                                  {{ $t('sumItem') }} : {{ $numberFormat(totalCount) }}
                                </th>
                                <th style="border-top : 1px solid #e3e3e3 !important;width: 300px">
                                  {{ $t('sum') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td rowspan="2">
                                  <div class="d-flex">
                                    <!--                                    <v-checkbox-->
                                    <!--                                      v-model="websocketWeight"-->
                                    <!--                                      class="mt-0 mb-0 mx-1"-->
                                    <!--                                      :label="$t('online')"-->
                                    <!--                                      hide-details-->
                                    <!--                                    />-->
                                    <v-checkbox
                                      v-model="scale"
                                      class="mt-0 mb-0 mx-1"
                                      :label="$t('scale')"
                                      value="active"
                                      hide-details
                                    />
                                    <div
                                      v-show="scale"
                                      class="mt-1 ms-3"
                                    >
                                      <segment-display :value="weight" />
                                    </div>
                                  </div>
                                  <div class="d-flex my-2">
                                    <v-checkbox
                                      v-model="taxStatus"
                                      class="mt-0 mb-0 mx-1"
                                      :label="$t('tax')"
                                      value="active"
                                      hide-details
                                    />
                                    <v-text-field
                                      v-if="taxStatus"
                                      v-model="taxPercent"
                                      :label="$t('taxPercent')"
                                      append-icon="mdi-percent-outline"
                                      outlined
                                      style="width: 135px"
                                      dense
                                      hide-details
                                      :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                                      type="number"
                                      clearable
                                    />
                                  </div>
                                </td>
                                <td>{{ $t('amount') }}</td>
                                <td>{{ $numberFormat(+total - +totalTax + +discount) }}</td>
                              </tr>
                              <tr>
                                <td style="background: antiquewhite;">
                                  {{ $t('discount') }}
                                </td>
                                <td
                                  style="background: antiquewhite"
                                  :class="{'d-flex' : percentDiscountStatus}"
                                >
                                  <money
                                    v-model="discount"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    :clearable="true"
                                    value-when-is-empty="0"
                                    :options="options"
                                    class="mb-3 dense"
                                    :append-icon="(!percentDiscountStatus ? 'mdi-percent-outline' : null)"
                                    :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : (sum > 0 ? (percentDiscountStatus ? true : false) : true))"
                                    @append="discountChangeStatus"
                                    @input="checkTotalDiscount"
                                  />
                                  <v-text-field
                                    v-if="percentDiscountStatus"
                                    v-model="discountPercent"
                                    append-icon="mdi-currency-usd"
                                    placeholder="%"
                                    class="ms-1"
                                    height="20"
                                    outlined
                                    dense
                                    type="number"
                                    max="100"
                                    min="0"
                                    @keyup="discountCheck"
                                    @blur="discountCheck"
                                    @click:append="discountChangeStatus"
                                  />
                                </td>
                              </tr>
                              <tr v-show="taxStatus">
                                <td
                                  class="d-flex"
                                  style="height: 48px !important;padding: 0px 10px !important;"
                                />
                                <td style="background: aliceblue;">
                                  {{ $t('tax') }}
                                </td>
                                <td style="background: aliceblue;">
                                  {{ $numberFormat(totalTax) }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-col
                                    v-if="payments"
                                    class="py-0"
                                  >
                                    <v-chip
                                      v-for="(item,key) in payments"
                                      :key="key"
                                      class="ma-2 my-1 mt-0"
                                      :close="(!item.chip ? false : true)"
                                      color="blue"
                                      outlined
                                      label
                                      @click:close="item.chip = false"
                                    >
                                      {{ $t(item.payments.type) }}
                                      - {{ $t('amount') }} : {{ $numberFormat(parseFloat(item.payments.amount)) }}  {{ item.payments.currency.symbol }}
                                      - {{ $t('number') }}  : {{ item.payments.id }}
                                      <v-icon
                                        v-if="!item.chip"
                                        color="green"
                                        class="mx-2"
                                        @click="item.chip = true"
                                      >
                                        mdi-refresh
                                      </v-icon>
                                      <v-icon
                                        v-if="!item.chip"
                                        color="pink"
                                      >
                                        mdi-trash-can-outline
                                      </v-icon>
                                    </v-chip>
                                  </v-col>
                                  <v-col
                                    v-if="checks"
                                    class="py-0"
                                  >
                                    <v-chip
                                      v-for="(item,key) in checks"
                                      :key="key"
                                      class="ma-2 my-1 mt-0"
                                      :close="(!item.chip ? false : true)"
                                      color="deep-orange"
                                      outlined
                                      label
                                      @click:close="item.chip = false"
                                    >
                                      {{ $t('check') }} {{ $t(item.checks.type) }}
                                      - {{ $t('amount') }} : {{ $numberFormat(parseFloat(item.checks.amount)) }}  {{ item.checks.currency.symbol }}
                                      - {{ $t('number') }}  : {{ item.checks.number }}
                                      <v-icon
                                        v-if="!item.chip"
                                        color="green"
                                        class="mx-2"
                                        @click="item.chip = true"
                                      >
                                        mdi-refresh
                                      </v-icon>
                                      <v-icon
                                        v-if="!item.chip"
                                        color="pink"
                                      >
                                        mdi-trash-can-outline
                                      </v-icon>
                                    </v-chip>
                                  </v-col>
                                </td>
                                <td>{{ $t('sumSell') }}</td>
                                <td>
                                  {{ $numberFormat(total) }}
                                </td>
                              </tr>
                              <tr v-if="returnSellProp">
                                <td rowspan="2" />
                                <td>{{ $t('sumReturnSell') }}</td>
                                <td>{{ $numberFormat(returnSellProp.total) }}</td>
                              </tr>
                              <tr v-if="returnSellProp">
                                <td>{{ $t('remain') }}</td>
                                <td>{{ $numberFormat(total - returnSellProp.total) }}</td>
                              </tr>
                              <tr>
                                <td colspan="4">
                                  <div class="d-flex my-2">
                                    <v-checkbox
                                      v-if="showClearing"
                                      v-model="clearingStatus"
                                      class="mt-0 mb-0 mx-1"
                                      :label="$t('clearing')"
                                      value="active"
                                      hide-details
                                    />
                                    <autocomplete
                                      v-if="clearingStatus && type !== 'presale'"
                                      ref="refBank"
                                      v-model="bank"
                                      class="ms-2"
                                      :title="$t('bank') + '/' + $t('cash')"
                                      :currency-prop="currency.id"
                                      type="bankCash"
                                    />
                                    <v-btn
                                      v-if="bank && clearingStatus && type == 'sell' && bank.pos"
                                      small
                                      outlined
                                      height="32"
                                      style="margin-right: 3px !important;"
                                      color="teal"
                                      @click="sendPriceToPOS(bank.pos, total)"
                                    >
                                      <v-icon
                                        color="teal"
                                        style="font-size: 22px"
                                      >
                                        mdi-point-of-sale
                                      </v-icon>
                                      {{ $t('sendPriceToPOS') }}
                                    </v-btn>
                                    <v-chip
                                      v-if="bank && clearingStatus"
                                      class="ms-2 "
                                      color="primary"
                                      label
                                      outlined
                                      hide-details
                                    >
                                      {{ $t('remain') }}   {{ $t('bank') + '/' + $t('cash') }} : {{ $numberFormat(parseFloat(bank.remain.currency_remain)) }} {{ (currency ? currency.name : '') }}
                                    </v-chip>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td colspan="4">
                                  <v-col
                                    class="pb-0 pt-0"
                                    cols="12"
                                  >
                                    <description
                                      ref="refContent"
                                      v-model="content"
                                      class="mt-1 mb-3"
                                      type="purchase"
                                    />
                                  </v-col>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 my-2">
            <v-col
              cols="12"
              class="py-1 px-1"
              md="2"
              sm="2"
              :class="{'mb-3' : isMobile}"
            >
              <template>
                <v-text-field
                  id="dueDateId"
                  v-model="dueDate"
                  :label="$t('dueDate')"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                  @keyup="dueDate = null"
                />

                <date-picker
                  v-model="dueDate"
                  element="dueDateId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="date"
                  :max="$store.state.endDate"
                  :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </template>
            </v-col>
            <v-col
              v-show="(type == 'presale' || type == 'sell'|| type == 'returnSell') && (bodyStatus == false || !isMobile)"
              cols="12"
              class="py-1 px-1"
              sm="2"
              md="2"
            >
              <v-text-field
                v-model="officialNumber"
                height="20"
                dense
                outlined
                class="mb-3 dense"
                clearable
                :label="$t('officialNumber')"
                @blur="getOfficialInvoiceNumber"
              />
            </v-col>
            <v-col
              class="py-1 px-1"
              cols="12"
              md="2"
              sm="2"
              style="height: 20px"
              :class="{'mb-5' : isMobile}"
            >
              <status
                v-model="status"
                :hideconfig="true"
                :type="type"
                :value="status"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="py-1 px-1"
              :class="{'mb-3' : isMobile}"
            >
              <tag
                v-model="tag"
                :solo="false"
                :input="tag"
                :height="25"
              />
            </v-col>
            <v-col
              v-show="showCurrency && !isMobile"
              cols="12"
              sm="2"
              md="2"
              class="py-1 px-1"
              :class="{'mb-3' : isMobile}"
            >
              <autocomplete
                ref="refCurrency"
                v-model="currency"
                :rules="[v => !!v || $t('is-required')]"
                :title="$t('currency')"
                type="currency"
                :init="defaultCurrency"
                :value="currency"
                :offline="offline"
                :set-offline="offline"
                @change="changeCurrency"
              />
            </v-col>
            <v-col
              v-show="showCurrency && !isMobile"
              cols="12"
              sm="2"
              md="2"
              :class="{'mb-0' : isMobile}"
              class="py-1 px-1"
            >
              <money
                v-model="currency_amount"
                :label="$t('currency-rate')"
                :dense="true"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="mb-3 dense"
              />
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
              :class="{'mb-3' : isMobile}"
              class="py-1 px-1"
            >
              <aicomplete
                v-model="branch"
                title="branch"
                type="branch"
                :set-init="true"
                :val="branch"
                :offline="offline"
                :set-offline="offline"
              />
            </v-col>
            <v-col
              cols="12"
              :class="{'mb-3' : isMobile}"
              md="2"
              sm="2"
              class="mb-0 px-1 py-1"
            >
              <v-select
                v-model="type"
                :label="$t('documentType')"
                :items="typeItems"
                :disabled="(this.$route.name === 'presaleEdit' || itemsProp ? false : true)"
                height="30"
                dense
                outlined
                item-value="value"
                item-text="text"
                item-disabled="disable"
                @input="checkProductsCount"
              />
            </v-col>
            <v-col
              cols="12"
              :class="{'mb-3' : isMobile}"
              md="2"
              sm="2"
              class="mb-0 px-1 py-1"
            >
              <autocomplete
                v-model="given"
                :title="$t('accountGiven')"
                :offline="offline"
                :set-offline="offline"
                type="given"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions class="pt-0 px-3 pb-0">
        <v-row class="ma-0">
          <v-col
            v-if="!id"
            cols="6"
            class="px-0 pt-0"
          >
            <v-btn
              v-if="bodyStatus == false && isMobile"
              color="primary"
              class="mr-0"
              @click="bodyStatus = true"
            >
              {{ $t('continuance') }}
            </v-btn>
            <v-btn
              v-if="(!id && bodyStatus || !isMobile) && !sellLinkProp "
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }} (f3)
            </v-btn>
            <v-btn
              v-if="sellLinkProp && bodyStatus "
              color="primary"
              block
              class="float-left mx-2"
              @click="goToSell"
            >
              {{ $t('sellInvoice') }}
            </v-btn>
          </v-col>
          <v-col
            v-if="id"
            cols="6"
            class="px-0 pt-0"
          >
            <v-btn
              v-if="bodyStatus == false && isMobile"
              color="primary"
              class="ms-0"
              @click="bodyStatus = true"
            >
              {{ $t('continuance') }}
            </v-btn>
            <v-btn
              v-if="id && bodyStatus || !isMobile"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2 pt-0 d-flex flex-row-reverse"
          >
            <v-btn
              v-if="bodyStatus == false && isMobile"
              color="green"
              class="float-left"
              @click="bodyStatus = true"
            >
              {{ (isMobile ? $t('sum-total') + ':' + $numberFormat(total) : '') }}
            </v-btn>
            <v-btn
              v-if="!isMobile && !sellLinkProp"
              color="grey"
              outlined
              class="float-left"
              @click="goTo('CashPayList')"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              v-if="isMobile && bodyStatus == true"
              color="grey"
              outlined
              class="float-left"
              @click="bodyStatus = false"
            >
              {{ $t('addProduct') }}
            </v-btn>
            <v-btn
              v-if="isMobile && bodyStatus == true && type == 'sell'"
              color="primary"
              outlined
              class="float-left mx-2"
              @click="goToReturnSell"
            >
              {{ $t('returnSell') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            class="pb-2 px-2"
            cols="12"
          >
            <print
              :data-prop="reportData"
              :report-prop="reportName"
              :resource-prop="reportName"
            />
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPriceChange"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Use Google's location service?
        </v-card-title>

        <v-card-text>
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="dialogPriceChange = false"
          >
            {{ $t('yes') }}
          </v-btn>

          <v-btn
            color="pink darken-1"
            text
            @click="dialogPriceChange = false"
          >
            {{ $t('no') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <p
            style="color: white"
            class="text-center"
          >
            {{ $t('syncData') }} ...
          </p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <Confirm ref="confirm" />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  import Description from '../../components/general/description/Description'
  import print from './../../components/general/printViewer/printViewer'
  import segmentDisplay from './../../components/general/7segment/index.vue'
  function initialData () {
    return {
      selected: [],
      numberForEdit: null,
      abrName: null,
      weight: null,
      tab: null,
      scale: false,
      uid: null,
      ouid: null,
      redirectUrl: true,
      websocketWeight: false,
      checkDiscountEdit: false,
      abrironPrinter: false,
      render: true,
      validBank: true,
      selectRow: null,
      given: null,
      offlineSaveStatus: null,
      offline: false,
      nextPermission: false,
      officialNumber: null,
      tableHeightInvoice: 380,
      showCurrency: true,
      reportData: null,
      reportName: null,
      plan: null,
      percentDiscountStatus: false,
      bodyStatus: false,
      dialogPriceChange: false,
      allowPriceChange: false,
      invoicePrintType: 'normal',
      printDialog: false,
      discountEdit: 0,
      checkNumber: false,
      checkOfficialNumber: false,
      deletDialog: false,
      showClearing: true,
      showSelect: false,
      showProductList: false,
      clearingStatus: false,
      filter: false,
      valid: true,
      number: null,
      bank: null,
      entrepot: null,
      payments: null,
      checks: null,
      account: null,
      dueDate: null,
      date: null,
      currency_amount: null,
      content: null,
      model: null,
      printType: 'fish',
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      currency: null,
      temp: null,
      taxPercent: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      typeItems: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      type: 'sell',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      search: null,
      discountPercent: false,
      taxStatus: false,
      totalCount: 0,
      discount: 0,
      totalDiscount: 0,
      totalTax: 0,
      totalFee: 0,
      sumRow: 0,
      sum: 0,
      appendTimer: 0,
      decimal: 0,
      weightInterval: null,
      autoPrint: true,
      totalDiscountType: false,
    }
  }
  export default {
    name: 'InvoiceIndex',
    components: {
      Products: () => import('../../components/general/Products/ProductsWithCategory.vue'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Description,
      print,
      segmentDisplay,
      autocomplete,
      Task,
    },
    mixins: [General],
    props: ['input', 'formType', 'refId', 'accountProp', 'itemsProp', 'sellLinkProp', 'returnSellProp'],
    data: function () {
      return initialData()
    },
    computed: {
      total: function () {
        var sum = parseFloat(this.sum) - parseFloat((this.totalDiscount !== '' ? this.totalDiscount : 0))
        this.checkBankRemain(sum)
        return sum.toFixed(this.decimal)
      },
    },
    sockets: {
      getValue: function (data) {
        this.weight = data
      },
    },
    watch: {
      returnSellProp (val) {
        this.onResize()
      },
      abrironPrinter (val) {
        localStorage.setItem('abrironPrinter', val)
      },
      showProductList (val, oldVal) {
        if (val) {
          localStorage.setItem('showProductListInvoice', val)
        } else {
          localStorage.removeItem('showProductListInvoice')
        }
      },
      account () {
        this.setFocus()
      // this.clearRows()
      },
      currency (val, old) {
        this.decimal = 0
        if (val) {
          this.decimal = val.decimal
          if (this.render) {
            this.currency_amount = val.amount
            this.bank = null
          }
        } else {
          this.currency_amount = null
        }
        if (this.render) {
        // this.clearRows()
        }
      },
      taxStatus (val, old) {
        if (val) {
          this.totalDiscountType = false
          this.totalDiscount = 0
          this.discount = 0
        }
        this.calcSum()
      },
      taxPercent (val, old) {
        if (this.taxStatus) {
          this.totalDiscountType = false
          this.totalDiscount = 0
          this.discount = 0
        }
        this.calcSum()
      },
      defaultCurrency () {
        if (this.defaultCurrency && !this.id) {
          this.$refs.refCurrency.setModel(this.defaultCurrency)
          this.currency_amount = this.defaultCurrency.amount
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      payments: {
        handler () {
          var app = this
          app.showClearing = true
          if (app.payments && app.payments.length > 0) {
            app.payments.map(function (value, key) {
              if (value.chip) {
                app.showClearing = false
                app.clearingStatus = false
                app.bank = null
              }
            })
          }
        // app.checks.map(function (value, key) {
        //   if (value.chip) {
        //     app.showClearing = false
        //     app.clearingStatus = false
        //     app.bank = null
        //   }
        // })
        },
        deep: true,
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      itemsProp (val) {
        if (val) {
          this.items = val
        } else {
          this.items = []
          this.addRow()
        }
      },
      offline () {
        if (this.offline && !this.callInvoiceByNumber) {
          this.getInvoiceNumberOffline()
        } else {
          this.getInvoiceNumber()
        }
        this.setCookie('offlineInvoice', this.offline)
      },
      scale (val) {
        if (val && val === 'active') {
          this.getWeight('weight')
          if (!this.websocketWeight) {
            this.getWeightClipboard()
          }
        } else {
          this.getWeight('weightOff')
          clearInterval(this.weightInterval)
        }
      },
    },
    activated: function () {
      this.beforeMount()
    },
    beforeMount () {
    // this.beforeMount()
    },
    mounted () {
      var app = this
      if (this.$route.name === 'invoiceCasher') {
        this.type = 'sell'
      }
      if (this.$route.name === 'returnSellCasher') {
        this.type = 'returnSell'
      }
      if (this.$route.name === 'purchase') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'returnPurchase') {
        this.type = 'returnPurchase'
      }
      if (this.$route.name === 'returnSell') {
        this.type = 'returnSell'
      }
      // this.offline = true
      if (localStorage.getItem('showProductListInvoice')) {
        this.showProductList = true
      }
      if (localStorage.getItem('abrironPrinter')) {
        this.abrironPrinter = localStorage.getItem('abrironPrinter')
      }
      this.taxPercent = this.$store.state.tax
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 40,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 40,
        },
        {
          text: this.$t('product') + '/' + this.$t('service'),
          sortable: false,
          value: 'product',
          width: 300,
        },
        {
          text: this.$t('unit'),
          sortable: false,
          value: 'unit',
          width: 140,
        },
        {
          text: this.$t('count'),
          sortable: false,
          value: 'count',
          width: 200,
        },
        {
          text: this.$t('fee'),
          sortable: false,
          value: 'fee',
          width: 200,
        },
        {
          text: this.$t('discount'),
          sortable: false,
          value: 'discount',
          width: 230,
        },
        {
          text: this.$t('tax'),
          sortable: false,
          value: 'tax',
          width: 160,
        },
        {
          text: this.$t('sum'),
          sortable: false,
          value: 'sum',
          width: 170,
        },
      ]
      var presaleDisable = false
      if (this.$route.name === 'presaleEdit' && this.id) {
        presaleDisable = true
      }
      this.typeItems = [
        {
          value: 'sell',
          text: this.$t('sell'),
        },
        {
          value: 'presale',
          text: this.$t('presale'),
        },
        {
          value: 'returnSell',
          text: this.$t('returnSell'),
          disable: presaleDisable,
        },
        {
          value: 'purchase',
          text: this.$t('purchase'),
          disable: presaleDisable,
        },
        {
          value: 'returnPurchase',
          text: this.$t('returnPurchase'),
          disable: presaleDisable,
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
      if (this.$route.params.id === null || this.$route.params.id === undefined) {
      // this.addRow()
      // this.currency = this.$store.state.currency
      // this.currency_amount = this.$store.state.currency.amount
      }
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize)
      })
      if (this.isMobile) {
        this.printType = 'fish'
      }
      // this.getAllProductsOffline(app.type)
      // this.getAllPersonOffline()
      this.getAbrOffline()
      if (app.type === 'returnSell') {
        this.$root.$on('createReturnSell', () => {
          app.redirectUrl = false
          app.create()
        })
      }
      app.getWeight()
      app.setDefaultCooki()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      printWithTools () {
        var local = localStorage.getItem('token')
        this.abrName = this.$store.state.abrName
        var data = {
          userId: JSON.parse(local).init.userId + '000',
          body: this.$data,
        }
        this.$socket.emit('setValue', JSON.stringify(data))
      },
      setFocus () {
        if (this.$refs.productCategoryRef) {
          this.$refs.productCategoryRef.setSearchFocus()
        }
      // this.$refs.searchRef.focus()
      },
      fullScreen () {
        document.requestFullscreen()
      // this.$refs.refComponent.$el
      },
      async getWeightClipboard () {
        var app = this
        app.weightInterval = setInterval(async function () {
          if (document.hasFocus()) {
            var clip = await navigator.clipboard.readText()
            if (app.isJsonString(clip)) {
              clip = JSON.parse(clip)
              app.weight = clip.weight
            }
          }
        }, 100)
      },
      isJsonString (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      getItemWeight (item) {
        var bc = new BroadcastChannel('test_channel')
        bc.postMessage('This is a test message.')
        item.count = parseFloat(this.weight)
      },
      async getWeight (type) {
        var app = this
        var data = {
          type: type,
          userId: this.$store.state.userId,
        }
        const clipText = await navigator.clipboard.writeText(JSON.stringify(data))
        app.copyClip = clipText
        setTimeout(async function () {
        // const clipText2 = await navigator.clipboard.writeText(0)
        // app.copyClip2 = clipText2
        }, 1000)
      // this.selectRow = item
      },
      addCount (item) {
        item.count++
        var app = this
        clearTimeout(this.appendTimer)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 100)
      },
      minusCount (item) {
        item.count--
        var app = this
        clearTimeout(this.appendTimer)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 100)
      },
      goToReturnSell () {
        // this.$root.$emit('createReturnSell')
        this.$router.push({ name: 'returnSellCasher', params: { accountProp: this.account, sellLinkProp: true } })
      },
      goToSell () {
        if (!this.$refs.form.validate()) return false
        var data = {
          total: this.total,
        }
        this.$router.push({ name: 'invoiceCasher', params: { returnSellProp: data } })
      },
      scrollToBottom (app) {
        setTimeout(function () {
          app.$refs.refScroll.scrollTop = app.$refs.refBody.scrollHeight
        }, 50)
      },
      setOffline (val) {
        this.offline = val
      },
      unitCalc (item) {
        if (item.product && item.unit) {
          var i = item.product.units.findIndex(x => x.unit_id === item.unit.id)
          if (i !== -1 && item.product.units[i].value) {
            return +item.product.units[i].value
          } else {
            return 1
          }
        }
      },
      unitItems (item) {
        if (item.product) {
          var units = [item.product.unit]
          if (item.product.units) {
            item.product.units.map(function (value, index) {
              value.unit.value = value.value
              units.push(value.unit)
            })
          }
          if (!item.unit) {
            item.unit = item.product.unit
          }
          return units
        } else {
          return []
        }
      },
      onResize () {
        var height = 480
        if (!this.isMobile && window.innerHeight < 750) {
          height = 507
        }
        if (this.isMobile) {
          height = 440 + (this.returnSellProp ? 70 : 0)
        }
        if (this.isMobile && window.innerHeight < 900 && window.innerHeight > 750) {
          height = 460 + (this.returnSellProp ? 70 : 0)
        }
        if (this.isMobile && window.innerHeight < 750) {
          height = 480 + (this.returnSellProp ? 70 : 0)
        }
        this.tableHeightInvoice = window.innerHeight - height
      },
      beforeMount () {
        if (this.accountProp) {
          this.account = this.accountProp
        }
        if (this.$route.params.id != null) {
          this.id = this.$route.params.id
          this.uid = this.$route.params.id
          this.show()
          this.render = false
        } else {
          this.defaultCurrency = this.getDefault('defaultCurrency')
          this.currency = this.$store.state.currency
          if (this.offline && !this.callInvoiceByNumber) {
            this.getInvoiceNumberOffline()
          } else {
            this.getInvoiceNumber()
          }
          if (this.items && this.items.length === 0) {
          // this.addRow()
          }
        }
        if (this.$store.state.currency && !this.id && !this.account) {
          this.currency = this.$store.state.currency
          this.currency_amount = this.$store.state.currency.amount
        }
        if (this.itemsProp) {
          this.items = this.itemsProp
        } else {
          if (!this.isMobile && !this.account && !this.id) {
            this.items = []
          // this.addRow()
          }
        }
      },
      feeValidate (value) {
        if (!value || parseFloat(value) <= 0) {
          return this.$t('is-required')
        } else {
          return true
        }
      },
      checkProductsCount () {
        var app = this
        if (this.items && this.items.length > 0) {
          this.items.map(function (value, index) {
            // value.product = null
            if (app.$refs['refProduct' + index] !== undefined) {
            // app.$refs['refProduct' + index].clear()
            }
          })
        }
      },
      zeroCountCheck (item) {
        if (parseFloat(item.count) === 0) {
          item.count = 1
          this.checkCount(item)
        }
      },
      discountChangeStatus () {
        this.percentDiscountStatus = !this.percentDiscountStatus
        this.taxStatus = false
      },
      discountCheck () {
        this.discount = 0
        this.totalDiscount = 0
        if (Number(this.discountPercent) > 100) {
          this.discountPercent = 100
        }
        if (Number(this.discountPercent) < 0) {
          this.discountPercent = 0
        }
        if (this.total > 0) {
          var discount = this.total * (this.discountPercent / 100)
          this.discount = discount.toFixed(this.decimal)
          this.checkTotalDiscount()
        }
      },
      checkBankRemain (sum) {
        var app = this
        app.validBank = true
        if (app.type === 'purchase' || app.type === 'returnSell') {
          if (this.clearingStatus && this.bank && sum > parseFloat(this.bank.remain.currency_remain)) {
            app.validBank = true
            app.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
            app.snakbarColor = 'pink'
            app.snakbar = true
          }
        }
      },
      getInvoiceNumber () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              callInvoice: app.callInvoiceByNumber,
              select: 'getInvoiceNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber && !app.callInvoiceByNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
                if (app.callInvoiceByNumber && res.invoice) {
                  app.id = res.invoice.uid
                  app.show()
                // app.$router.push({ name: 'invoiceCasherEdit', params: { id: res.invoice.uid, tabName: res.invoice.number } })
                } else {
                  app.number = res.number
                }
              }
              app.number = res.number
              app.checkNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
              app.isLoading = false
            })
        }, 50)
      },
      callInvoiceById (e) {
        if (e && e.key === 'Enter') {
          this.loading = true
          var app = this
          app.isLoading = true
          this.clearForm()
          clearTimeout(this.timer)
          this.timer = setTimeout(function () {
            app.$axios.get(app.$endpoint + 'getdetail', {
              params: {
                id: app.numberForEdit,
                select: 'getInvoiceUidById',
              },
            })
              .then(res => {
                res = res.data
                if (res.uid) {
                  app.id = res.uid
                  app.show()
                }
              })
              .catch(err => {
                this.serverErrorHandeler(err)
              })
              .finally(function () {
                app.loading = false
                app.isLoading = false
              })
          }, 50)
        }
      },
      getOfficialInvoiceNumber () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.officialNumber,
              select: 'getOfficialInvoiceNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkOfficialNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.officialNumber = res.number
              }
              app.checkOfficialNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      changeProduct (item) {
        if (this.type === 'sell' || this.type === 'returnPurchase' || this.type === 'presale') {
          if (this.currency && item.product && item.product.price && this.currency.id === this.$store.state.currency.id) {
            item.fee = item.product.price
          } else {
            if (!this.id && !this.itemsProp) {
            // item.fee = 0
            }
          }
        }
      },
      clearRow (item) {
        item.fee = 0
        item.count = 0
        item.discount = 0
        item.discountPercent = 0
        item.tax = 0
      },
      clearRows () {
        this.items.map(function (value, index) {
          value.fee = 0
          value.count = 0
          value.discount = 0
          value.discountPercent = 0
          value.tax = 0
        })
      },
      changePercent (val) {
        this.discountPercent = val
        this.percentDiscountStatus = true
      },
      append (product) {
        var count = (product.count ? product.count : 1)
        var stock = 20000000
        if (!this.offline && product.type === 'product') {
          stock = (product.stock ? product.stock.count : 0)
          if (this.type === 'sell' || this.type === 'returnPurchase') {
            if (!product.stock || product.stock.count <= 0) {
              this.snakbarText = this.$t('alert-is-not-enough-inventory')
              this.snakbarColor = 'pink'
              this.snakbar = true
              return false
            }
            if (product.stock && product.stock.count < 1) {
              count = parseFloat(product.stock.count)
            }
          }
        }
        var index = -1
        // if (this.items && this.items.length == 0) {
        //   this.addRow()
        // }
        if (this.items && this.items.length > 0 && !this.items[0].product) {
          this.items.splice(0, 1)
        }
        index = this.items.findIndex(x => (x.product ? x.product.id === product.id : null))
        if (index !== -1) {
          if (parseFloat(stock) - parseFloat(this.items[index].count) - parseFloat(count) >= 0) {
            this.items[index].count = parseFloat(this.items[index].count) + parseFloat(count)
            if (this.type === 'sell' || this.type === 'presale') {
              if (product && !product.price) {
                this.getPrice(this.items[index])
              }
            }
          }
        } else {
          if (this.scale && this.scale === 'active' && product.unit && product.unit.type === 'jointed') {
            if (product.unit.name === 'Kg') {
              count = parseFloat(this.weight / 1000)
            } else {
              count = parseFloat(this.weight)
            }
          }
          var price = (product.price ? product.price : 0)
          this.addRow(product, count, price)
        }
        var app = this
        clearTimeout(this.appendTimer)
        this.scrollToBottom(this)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 250)
      },
      getPrice (item) {
        var app = this
        clearTimeout(this.timer)
        if (!this.showProductList) {
          app.isLoading = true
        }
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: 'getPrice',
              currency_id: app.currency.id,
              count: item.count,
              product_id: item.product.id,
              category_id: (app.account && app.account.category_id ? app.account.category_id : -1),
            },
          })
            .then(res => {
              res = res.data
              if (res.price > 0) {
                item.fee = res.price
              } else {
                item.fee = 0
              }
              if (item.fee > 0 && item.count > 0) {
                if (res.discount.amount) {
                  item.discount = res.discount.amount
                }
                if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                  var discount = (parseFloat(item.fee) * parseFloat(item.count)) * (parseFloat(res.discount.percent) / 100)
                  item.discount = discount
                }
              }
              app.calcSum()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 500)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
      calcSum () {
        var app = this
        app.totalTax = 0
        app.totalDiscount = (this.discountEdit ? this.discountEdit : 0)
        app.totalCount = 0
        app.totalFee = 0
        app.sum = 0
        var sumDiscount = 0
        // if (!this.discountPercent) {
        //   this.discount = 0
        // }
        this.items.map(function (value, index) {
          if (parseFloat(value.count) * parseFloat(value.fee) < parseFloat(value.discount)) {
            value.discount = 0
            app.discount = 0
            app.totalDiscount = 0
          }
          if (app.totalDiscountType) {
            value.discount = 0
            value.tax = 0
          } else {
            sumDiscount = sumDiscount + parseFloat(value.discount)
            app.calcTax(value)
          }
          app.totalFee = parseFloat(value.count) * parseFloat(value.fee) + parseFloat(app.totalFee)
          app.totalCount = parseFloat(value.count) + parseFloat(app.totalCount)
          app.totalTax = parseFloat(value.tax) + parseFloat(app.totalTax)
          var rowPrice = parseFloat(value.fee * value.count) - parseFloat((value.discount === '' || !value.discount ? 0 : value.discount)) + parseFloat(value.tax)
          app.sum = parseFloat(rowPrice) + parseFloat(app.sum)
        })
        app.totalFee = app.totalFee.toFixed(this.decimal)
        app.totalTax = app.totalTax.toFixed(this.decimal)
        if (sumDiscount > 0) {
          app.discount = sumDiscount
        // app.totalDiscount = sumDiscount
        }
        this.discountEdit = 0
      },
      checkTotalDiscount () {
        this.taxStatus = false
        this.totalDiscountType = true
        this.calcSum()
        // if (this.discountPercent) {
        //   if (parseFloat(this.discount) > 100) {
        //     this.discount = 0
        //   }
        //   var discount = parseFloat(this.sum) * (parseFloat(this.discount) / 100)
        //   this.totalDiscount = discount
        // } else {
        this.totalDiscount = this.discount
        // }
        if (this.discountPercent === false && parseFloat(this.discount) > parseFloat(this.sum)) {
          this.discount = 0
          this.totalDiscount = 0
        }
      },
      calcTax (item) {
        if (this.taxStatus === 'active') {
          var tax = (parseFloat(item.fee * item.count) - parseFloat((item.discount === '' || !item.discount ? 0 : item.discount))) * this.taxPercent / 100
          item.tax = tax.toFixed(this.$store.state.currency.decimal)
        } else {
          item.tax = 0
        }
      },
      changeCurrency () {
        this.bankRemain = 0
        this.currency_amount = this.currency.amount
        this.options = {
          locale: 'en-US',
          prefix: '',
          suffix: this.currency.name,
          precision: 0,
        }
      },
      addRow (product = null, count = 0, price = 0) {
        this.items.push({
          product: product,
          count: count,
          countEdit: 0,
          fee: price,
          discount: 0,
          discountPercent: 0,
          tax: 0,
          unit: null,
          content: 0,
        })
        if (this.type === 'sell' && product && !product.price) {
          var index = this.items.findIndex(x => x.product.id === product.id)
          this.getPrice(this.items[index])
        }
      },
      remove (item) {
        var i = this.items.indexOf(item)
        this.items.splice(i, 1)
        this.deleteItem = null
        this.calcSum()
        this.deletDialog = false
        this.setFocus()
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
          // typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      checkProduct (item, key) {
        if (item) {
          var index = this.items.findIndex(x => x.product.id === item.id)
          if (index !== key) {
            this.$refs['refProduct' + key].clear()
            this.snakbarText = this.$t('alert-product-is-repetitive')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        }
      },
      checkDiscount (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
        }
        item.discountPercent = this.itemDiscountPercentCalc(item)
        this.calcSum()
      },
      checkDiscountPercent (item) {
        this.totalDiscountType = false
        this.totalDiscount = 0
        this.discount = 0
        item.discount = (parseFloat(item.fee * item.count) * (item.discountPercent / 100)).toFixed(this.decimal)
        if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
          item.discount = 0
          item.discountPercent = 0
        }
        this.calcSum()
      },
      itemDiscountPercentCalc (item) {
        return (parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100
      },
      checkCount (item) {
        if (!this.offline && (this.type === 'sell' || this.type === 'presale' || this.type === 'returnPurchase')) {
          var productStock = (item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0)
          if (item.product && item.product.type === 'product' && this.$store.state.negative_inventory === 'no' && parseFloat(item.count) > productStock + parseFloat((this.$route.name !== 'presaleEdit' ? item.countEdit : 0))) {
            this.snakbarText = this.$t('alert-inventory-is-not-enough')
            this.snakbarColor = 'pink'
            this.snakbar = true
          // item.count = 0
          } else {
            if (this.$route.name !== 'presaleEdit' && item.product && !item.product.price) {
              if (this.type === 'sell' || this.type === 'presale') {
                this.getPrice(item)
              }
            }
          }
        }
        this.calcSum()
      },
      removegroup () {
        var app = this
        app.selected.map(function (value, key) {
          app.remove(value, key)
        })
      },
      createOffline () {
        if (!this.$refs.form.validate()) return false
        var app = this
        var token = JSON.parse(localStorage.getItem('token'))
        var list = JSON.parse(localStorage.getItem('invoice'))
        if (!list) {
          list = []
        }
        this.ouid = token.init.userId + '@' + Date.now() + '@' + this.number
        list.push(this.$data)
        localStorage.setItem('invoice', JSON.stringify(list))
        localStorage.setItem('invoiceNumber', this.number)
        if (!this.$store.state.offlineInvoiceTrigger) {
          this.createInvoiceOffline()
        }
        this.$store.commit('SET_OFFLINEINVOICETRIGGER', true)
        if (app.autoPrint && app.redirectUrl) {
          if (app.type === 'sell' || app.type === 'presale') {
            if (app.printType === 'normal') {
              app.$router.push({ name: 'invoicePrint', params: { id: this.ouid, offlineProp: true } })
            } else {
              var numberPrintForNewInvoice = (this.type === 'sell' && !this.id && this.$store.state && this.$store.state.allConfig && this.$store.state.allConfig.printNumberForNewInvoice === 'active' ? true : null)
              app.$router.push({ name: 'invoiceRollprint', params: { id: this.ouid, backUrl: 'invoiceCasher', offlineProp: true, abrironPrinterProp: app.abrironPrinter, numberPrint: numberPrintForNewInvoice } })
            }
          } else {
            app.goTo(app.type + 'List')
          }
        }
        app.items = []
        app.account = null
        if (app.type === 'sell' && app.returnSellProp) {
        // app.$root.$emit('createReturnSell')
        }
        app.redirectUrl = true
      },
      create () {
        var app = this
        var checkVisitor = false
        if (!this.$refs.form.validate()) return false
        // this.items.map(function (value, index) {
        //   if (!value.product) {
        //     this.remove(value, index)
        //   }
        // })
        if (this.type === 'sell' && this.$store.state.allConfig && this.$store.state.allConfig.userInt && this.$store.state.allConfig.userInt.visitor === 'active') {
          checkVisitor = true
        }
        if (this.items.length === 0) {
          app.snakbarText = app.$t('noItems')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (!this.account) {
          app.snakbarText = app.$t('noAccount')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (this.offline && !checkVisitor) {
        // this.createOffline()
        // this.clearForm()
        // return false
        }
        app.snakbar = false
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'invoice', this.$data)
          .then(res => {
            res = res.data
            app.nextPermission = true
            if (res.status === 'success') {
              app.snakbarText = app.$t('registered')
              app.snakbarColor = 'green'
              app.snakbar = true
              if (app.autoPrint && app.redirectUrl) {
                if (app.type === 'sell' || app.type === 'presale') {
                  if (!app.abrironPrinter) {
                    app.$emit('close', app.$route)
                    if (app.printType === 'normal') {
                      app.$router.push({ name: 'invoicePrint', params: { id: res.data.uid } })
                    } else {
                      app.$router.push({ name: 'invoiceRollprint', params: { id: res.data.uid } })
                    }
                  } else {
                    if (this.type === 'sell' && !this.id && this.$store.state && this.$store.state.allConfig && this.$store.state.allConfig.printNumberForNewInvoice === 'active') {
                      app.invoicePrintType = 'number'
                    } else {
                      app.invoicePrintType = 'normal'
                    }
                    app.id = res.data.id
                    app.printWithTools()
                    app.id = null
                  // var numberPrintForNewInvoice =
                  // app.$router.push({ name: 'invoiceRollprint', params: { id: res.data.uid, backUrl: (checkVisitor ? 'invoiceCasher' : 'invoiceCasher'), abrironPrinterProp: app.abrironPrinter, numberPrint: numberPrintForNewInvoice } })
                  }
                } else {
                  app.goTo(app.type + 'List')
                }
              }
              if (app.type === 'sell' && app.returnSellProp) {
              // app.$root.$emit('createReturnSell')
              }
              if (checkVisitor) {
                app.account = null
              }
              app.redirectUrl = true
              app.clearForm()
            } else {
              app.snakbarText = app.$t('error')
              app.snakbarColor = 'green'
              app.snakbar = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.nextPermission = false
            this.redirectUrl = true
            this.isLoading = false
          })
      },
      update () {
        var app = this
        app.snakbar = false
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'invoice/' + this.uid, this.$data)
          .then(res => {
            res = res.data
            // app.nextPermission = true
            app.clearableForm()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.nextPermission = false
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + this.id + '/edit', {
          params: {
            id: this.id,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.id = res.id
              app.uid = res.uid
              app.currency = res.currency
              app.decimal = (res.currency ? res.currency.decimal : 0)
              app.currency_amount = res.currency_amount
              app.number = res.number
              app.officialNumber = res.official_number
              app.content = res.content
              app.date = res.date
              app.given = res.given
              app.type = res.type
              app.items = res.article
              app.account = res.customer
              app.entrepot = (res.entrepot ? res.entrepot.entrepot : null)
              app.dueDate = res.due_date
              app.branch = res.branch
              app.payments = res.payments
              app.checks = res.checks
              app.status = (res.last_status ? res.last_status.status : null)
              app.discount = res.discount
              app.plan = (res.plan ? res.plan.plan : null)
              app.totalDiscount = res.discount
              app.items.map(function (value, index) {
                if (value.discount && value.discount > 0) {
                  app.checkDiscountEdit = true
                }
              })
              if (!app.checkDiscountEdit) {
                app.discountEdit = res.discount
              }
              // app.totaltax = res.tax
              if (res.tax > 0) {
                app.taxStatus = 'active'
                app.taxPercent = res.tax_percent
              }
              if (res.tags) {
                app.tag = res.tags
                app.more = true
              }
              setTimeout(function () {
                app.render = true
              }, 1000)
              app.calcSum()
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getInvoiceNumberOffline () {
        if (this.type === 'returnPurchase' || this.type === 'purchase') {
          return false
        }
        var number = JSON.parse(localStorage.getItem('invoiceNumber'))
        if (!number) {
          number = 1
        } else {
          number = +number + 1
        }
        this.number = number
        this.setFocus()
      },
      clearableForm () {
        this.id = null
        this.account = null
        this.numberForEdit = null
        this.clearForm()
      },
      clearForm () {
        this.selected = []
        this.render = true
        this.bodyStatus = false
        this.printDialog = false
        this.deletDialog = false
        this.showClearing = true
        this.showSelect = false
        this.showProductList = false
        // this.clearingStatus = false
        this.filter = false
        this.valid = true
        this.number = null
        // this.bank = null
        this.given = null
        // this.entrepot = null
        this.payments = null
        this.uid = null
        this.checks = null
        this.officialNumber = null
        // this.account = null
        this.dueDate = null
        // this.date = null
        // this.currency_amount = null
        this.content = null
        this.model = null
        this.from = 1
        this.taskDialog = null
        this.id = null
        this.status = null
        this.tag = null
        this.temp = null
        this.deleteItem = null
        this.sellStatus = null
        this.items = []
        this.dialog = null
        this.timer = 0
        this.isLoading = false
        this.snakbar = false
        this.taskId = null
        this.snakbarText = null
        this.loading = false
        this.search = null
        this.discountPercent = false
        this.taxStatus = false
        this.totalCount = 0
        this.discount = 0
        this.totalDiscount = 0
        this.totalTax = 0
        this.totalFee = 0
        this.sumRow = 0
        this.sum = 0
        this.totalDiscountType = false
        if (this.offline && !this.callInvoiceByNumber) {
          this.getInvoiceNumberOffline()
        } else {
          this.getInvoiceNumber()
        }
        if (!this.autoPrint) {
          this.account = null
        }
        this.addRow()
        this.$refs.form.resetValidation()
        this.setFocus()
      },
    },
    beforeRouteLeave (to, from, next) {
      if (!this.nextPermission) {
        this.leavePage(to, from, next)
      } else {
        next()
      }
      next(false)
    },
  }
</script>

<style scoped>
.v-application .overflow-y-auto {
  overflow-y: unset !important;
}
</style>
